import { cn } from "@/lib/utils";

interface ProductsSectionProps {
  className?: string;
  children: React.ReactNode;
}

/**
 * Wrapper component for reusing the tailwind classes for the products section.
 * @param param0 
 * @returns 
 */
export function ProductsSection({ className, children }: ProductsSectionProps) {
  return (
    <section className={cn("container mx-auto my-4 md:my-12 max-w-7xl", className)}>
      {children}
    </section>
  )
}